import { Product } from "@/types/types";
import { ensureIsActive } from "@/utils/product/ensureIsActive";

export function hasAvailableVariantsMatchingColour(
  product: Product,
  colour: string | null | undefined,
) {
  const activeProduct = ensureIsActive(product);

  if (!activeProduct) {
    return false;
  }

  return activeProduct.variants
    .filter(
      (variant) =>
        "differentiators" in variant &&
        variant.differentiators?.colour === colour,
    )
    .some((variant) => variant.availability.availableToOrder);
}
